import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import DirectorProfile from '../pages/director-profile/page';
import PrivacyPolicy from '../pages/privacy-policy/page';
import NewsPage from '../pages/news/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/director-profile',
    element: <DirectorProfile />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicy />,
  },
  {
    path: '/news',
    element: <NewsPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
